'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactRedux = require('react-redux');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _dropbox = require('dropbox');

var _dropbox2 = _interopRequireDefault(_dropbox);

var _utils = require('helpers/utils');

var _components = require('components');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var service = 'dropbox';

var DropboxConnectButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user
  };
}), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(DropboxConnectButton, _Component);

  function DropboxConnectButton() {
    var _ref;

    (0, _classCallCheck3.default)(this, DropboxConnectButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropboxConnectButton.__proto__ || (0, _getPrototypeOf2.default)(DropboxConnectButton)).call.apply(_ref, [this].concat(args)));

    _this.onAuth = function (e) {
      window.removeEventListener('onDropboxAuth', _this.onAuth);
      _this.authWindow.close();
      _this.authWindow = null;

      var accessToken = e.detail.access_token;
      if (_this.state.isMounted) {
        _this.setState({ accessToken: accessToken });
      }
    };

    _this.state = { accessToken: null };
    return _this;
  }

  (0, _createClass3.default)(DropboxConnectButton, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.Dropbox = null;
    }
  }, {
    key: 'initDropboxClient',
    value: function initDropboxClient(params) {
      this.Dropbox = null;
      this.Dropbox = new _dropbox2.default((0, _extends3.default)({ clientId: _config2.default.app.dropbox.appKey }, params));
    }
  }, {
    key: 'connect',
    value: function connect() {
      this.initDropboxClient();
      var authUrl = this.Dropbox.getAuthenticationUrl(document.location.origin + '/processing/cloudauth/dropbox');
      this.authWindow = (0, _utils.popupWindowCenter)(authUrl, service, 360, 460);
      window.addEventListener('onDropboxAuth', this.onAuth);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          connectClassName = _props.connectClassName,
          disconnectClassName = _props.disconnectClassName;
      var accessToken = this.state.accessToken;

      var isConnected = !!(0, _get4.default)(user, 'dropboxToken', false);

      return _react2.default.createElement(_components.CloudConnectButton, {
        isConnected: isConnected,
        connectClassName: connectClassName,
        disconnectClassName: disconnectClassName,
        accessToken: accessToken,
        service: service,
        connect: this.connect
      });
    }
  }]);
  return DropboxConnectButton;
}(_ClientSideComponent2.default), _class3.propTypes = {
  connectClassName: _propTypes2.default.string,
  disconnectClassName: _propTypes2.default.string,
  user: _propTypes2.default.object
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'connect', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'connect'), _class2.prototype)), _class2)) || _class);
exports.default = DropboxConnectButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Dropbox/DropboxConnectButton.js
// module id = 1988
// module chunks = 1